export const ToInt  = (input) => {
  let onlyNums = input.replace(/[^0-9]/g, '');
  return (onlyNums === '' ? 0 : parseInt(onlyNums))
}

export const ToReal = (input) => {
  let onlyNums = input.replace(/[^0-9.]/g, '');
  return (onlyNums === '' ? '' : onlyNums)
}

export const ToDuration = (input) => {
  let onlyNums = input.replace(/[^0-9]/g, '');
  if(onlyNums && onlyNums.length > 2 && onlyNums[0] == 0) {
    onlyNums = onlyNums.replace('0', '')
  } else if(onlyNums && onlyNums.length === 1) {
    onlyNums = ('0' + onlyNums)
  }
  return ((onlyNums === '' || onlyNums == '0') ? '00' : (onlyNums))
}

